"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEnquiryDetailsMediaDto = instanceOfEnquiryDetailsMediaDto;
exports.EnquiryDetailsMediaDtoFromJSON = EnquiryDetailsMediaDtoFromJSON;
exports.EnquiryDetailsMediaDtoFromJSONTyped = EnquiryDetailsMediaDtoFromJSONTyped;
exports.EnquiryDetailsMediaDtoToJSON = EnquiryDetailsMediaDtoToJSON;
exports.EnquiryDetailsMediaDtoToJSONTyped = EnquiryDetailsMediaDtoToJSONTyped;
/**
 * Check if a given object implements the EnquiryDetailsMediaDto interface.
 */
function instanceOfEnquiryDetailsMediaDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function EnquiryDetailsMediaDtoFromJSON(json) {
    return EnquiryDetailsMediaDtoFromJSONTyped(json, false);
}
function EnquiryDetailsMediaDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'altText': json['altText'] == null ? undefined : json['altText'],
    };
}
function EnquiryDetailsMediaDtoToJSON(json) {
    return EnquiryDetailsMediaDtoToJSONTyped(json, false);
}
function EnquiryDetailsMediaDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileName': value['fileName'],
        'fileUrl': value['fileUrl'],
        'fileType': value['fileType'],
        'altText': value['altText'],
    };
}
